import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { RestService } from 'src/app/services/rest.service';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { CommonServiceService } from 'src/app/services/common-service.service';

@Component({
  selector: 'app-salesrep-sales-analytics',
  templateUrl: './salesrep-sales-analytics.component.html',
  styleUrls: ['./salesrep-sales-analytics.component.scss']
})
export class SalesrepSalesAnalyticsComponent implements OnInit {
  salesrepSalesArray: any = {
    salesrepSalesList: [],
    salesrepSalesSummary: {}
  };
  userInfo: any;
  filters = {
    ventureId: 'all',
    salesrepId: null,
    type: 'all',
    fromDate: null,
    toDate: null
  };
  ventures: any = [];
  teamList: any = [];
  dropdownSettings:IDropdownSettings={};
  selectedItems = [];

  constructor(
    private restService: RestService,
    public commonService: CommonServiceService,
    private authService: AuthServiceService
  ) { }

  ngOnInit(): void {
    this.userInfo = this.authService.getUserInfo();
    let path:any;
    if(this.userInfo.scopes.includes('SALESREP_PRIVILEGE')) {
      path = 'salesrep/assigned-ventures/' + this.userInfo.salesrepId;
      this.dropdownSettings = {
        idField: 'ventureId',
        textField: 'ventureName',
      };
    } else if(this.userInfo.scopes.includes('MARKETER_SUPER_PRIVILEGE') || this.userInfo.scopes.includes('MARKETER_BASIC_PRIVILEGE')) {
      path = 'marketer/venture/getVenturesList';
      let teamUrl = 'marketer/get-markerter-teams';
      let data = {
        'tenantId': this.userInfo.tenantId,
        'marketerId': this.userInfo.marketerId
      };
      this.restService.submitPostRequest(teamUrl,data).subscribe(response => {
        this.teamList = response.teams;
      });
      this.dropdownSettings = {
        idField: 'ventureId',
        textField: 'displayName',
      };
    }
    this.restService.submitGetRequest(path).subscribe(response => {
      this.ventures = response.data;
    });
  }

  getPerformances() {
    let url;
    this.filters.ventureId = this.selectedItems.toString();
    let venture = (this.filters.ventureId != 'all' && this.filters.ventureId != null) ? '&ventureIdList='+this.filters.ventureId :'';
    let type = this.filters.type?'&type='+this.filters.type:'';
    let fromDate = this.filters.fromDate?'&fromDate='+this.filters.fromDate:'';
    let toDate = this.filters.toDate?'&toDate='+this.filters.toDate:'';
    let hasSalesrepId = false;
    if(this.userInfo.scopes.includes('SALESREP_PRIVILEGE')) {
      hasSalesrepId = true;   
      url = 'generic/salesrep/sales/analytics?' + 'salesrepId='+this.userInfo.salesrepId+venture+type+fromDate+toDate;
    } else if(this.userInfo.scopes.includes('MARKETER_SUPER_PRIVILEGE') || this.userInfo.scopes.includes('MARKETER_BASIC_PRIVILEGE')) {
      if(this.filters.salesrepId) {
        hasSalesrepId = true;
        url = 'generic/salesrep/sales/analytics?' + 'salesrepId='+this.filters.salesrepId+venture+type+fromDate+toDate;
      } else {
        hasSalesrepId = false;
      }
    }
    if(hasSalesrepId) {
      this.restService.getSales(url).subscribe(response => {
        if (response.data != null && response.data != undefined) {
          this.salesrepSalesArray = response.data;
        }
      },
      (error) => {
        console.log(error.status);
      });
    } else {
      alert("please select salesrep");
    }
  }

  onItemSelect(item: any) {
    this.selectedItems.push(item.ventureId)
  }

  onItemDeSelect(item: any) {
    this.selectedItems = this.selectedItems.filter(ele => {
      return ele != item.ventureId
    });
  }

  onSelectAll(items: any) {
    this.selectedItems = [];
    this.ventures.forEach(element => {
      this.selectedItems.push(element.ventureId)
    });
  }

  onUnSelectAll() {
    this.selectedItems = []
  }
}
